<template>
  <el-main class="userdetail">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/vacation' }">休假管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/vacation/detail?uid=${form.user_id}` }">休假申请</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="holiday-head">
      <div class="holi-body left">
        <div class="hold-head-title">{{ holidayDetail.name }}</div>
        <div class="hold-head-content">
          <div v-for="(item, index) in holidayDetail.description" :key="`holi_${index}`">{{ item }}</div>
        </div>
      </div>
      <div class="holi-body right">
        <div class="holiday-box" :class="`holi${holidayDetail.id}`">
          <div class="box-title">{{ holidayDetail.name }}</div>
          <!-- 年假 -->
          <div class="box-info" v-if="holidayDetail.id == '1'">已休：{{ userArr.holiday?.annual_days }} / {{
            userArr.holiday?.annual_total_days }}</div>
          <!-- 婚假 -->
          <div class="box-info" v-if="holidayDetail.id == '2'">已休：{{ userArr.holiday?.marriage_days }} / {{
            userArr.holiday?.marriage_total_days }}</div>
          <!-- 产假 -->
          <div class="box-info" v-if="holidayDetail.id == '3'">已休：{{ userArr.holiday?.maternity_days }} / {{
            userArr.holiday?.maternity_total_days }}</div>
          <!-- 陪产假 -->
          <div class="box-info" v-if="holidayDetail.id == '4'">已休：{{ userArr.holiday?.paternity_days }} / {{
            userArr.holiday?.paternity_total_days }}</div>
          <!-- 调休 -->
          <div class="box-info" v-if="holidayDetail.id == '5'">已休：{{ userArr.holiday?.compensatory_days }} / {{
            userArr.holiday?.compensatory_total_days }}</div>
          <!-- 事假 -->
          <div class="box-info" v-if="holidayDetail.id == '6'">已休：{{ userArr.holiday?.personal_days }}</div>
          <!-- 病假 -->
          <div class="box-info" v-if="holidayDetail.id == '7'">已休：{{ userArr.holiday?.sick_days }}</div>
          <!-- 丧假 -->
          <div class="box-info" v-if="holidayDetail.id == '8'">已休：{{ userArr.holiday?.bereavement_days }}</div>
        </div>
      </div>
    </div>
    <!-- 申请信息 -->
    <div class="base1">
      <h3 class="ntitle">申请信息</h3>
      <ul>
        <li>
          <p>
            <label>姓名：</label><a>{{ userArr.realname }} {{ userArr.en_name }} </a>
          </p>
          <p>
            <label>职位：</label><a>{{ userArr.role?.role_name }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>部门：</label><a>{{ userArr.department?.en_name }}</a>
          </p>
          <p>
            <label>直属领导：</label><a>{{ userArr.leader_name }} {{ userArr.leader_en_name }}</a>
          </p>
        </li>
      </ul>
    </div>
    <!-- 休假信息 -->
    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">休假信息</div>
        <el-form-item label="选择休假类型:" prop="contract_type">
          <el-col :span="12">
            <el-select v-model="form.holiday_id" placeholder="选择一个假期类型" style="width: 100%;"
              @change="e => holiInfoChange(e)">
              <el-option :label="v.name" :value="v.id" v-for="(v, i) in typeList" :key="`type_${i}`"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择调休记录:" prop="record_id" v-if="form.holiday_id == '5'">
          <el-col :span="12">
            <el-select v-model="form.record_id" placeholder="选择一个调休记录" style="width: 100%;">
              <el-option :label="`关联：${v.projectArr ? v.ncbnStr : (v.brandArr?.brand ? v.brandArr?.brand : v.supplement_desc)}_总计：${v.days}天`" :value="v.id" v-for="(v, i) in restList" :key="`res_${i}`"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="休假说明：" prop="reason">
          <el-col :span="12">
            <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
              v-model="form.reason">
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="休假起止日期：" prop="time">
          <el-col :span="4" style="margin-right: 20px;">
            <el-date-picker v-model="form.start_date" type="date"
              :picker-options="form.is_replace == '1' ? null : pickerOptions" value-format="yyyy-MM-dd"
              style="width: 100%;" @change="detailDayChange()">
            </el-date-picker>
          </el-col>
          <el-col :span="4">
            <el-select v-model="form.start_time" placeholder="请选择" style="width: 100%;" @change="detailDayChange()">
              <el-option label="上午" value="1"></el-option>
              <el-option label="下午" value="2"></el-option>
            </el-select>
          </el-col>
          <template>
            <el-col :span="1" style="text-align: center;">—</el-col>
            <el-col :span="4" style="margin-right: 20px;">
              <el-date-picker v-model="form.end_date" type="date"
                :picker-options="form.is_replace == '1' ? null : pickerOptions" value-format="yyyy-MM-dd"
                style="width: 100%; " @change="detailDayChange()">
              </el-date-picker>
            </el-col>
            <el-col :span="4" style="margin-right: 20px;">
              <el-select v-model="form.end_time" placeholder="请选择" style="width: 100%;" @change="detailDayChange()">
                <el-option label="上午" value="1"></el-option>
                <el-option label="下午" value="2"></el-option>
              </el-select>
            </el-col>
          </template>
        </el-form-item>
        <!-- 申请天数 -->
        <el-form-item label="申请天数：" prop="apply_days">
          <el-col :span="12">
            <div v-if="form.apply_days">
              {{ form.apply_days_word }}
            </div>
          </el-col>
        </el-form-item>
        <!-- 休假证明 -->
        <template>
          <ul class="anlist">
            <li v-for="(item, index) in job_file_list" :key="index">
              <div class="abox">
                <el-form-item :label='`新增附件${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3" v-if="form.status != '5'">
                    <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, 'job_file_list', 'upFile', item, index)">
                      <el-button size="small" style="width: 80px;">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{
                          item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                          target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" icon="el-icon-minus" @click="removeJob(job_file_list, index)" circle></el-button>

            </li>
            <el-button type="primary" style="margin: 0 0 15px 150px" class="addbtn"
              @click="addJob(job_file_list)">新增附件</el-button>
          </ul>
        </template>
        <div class="formtitle" v-if="form.is_replace != '1'">职务代理</div>
        <ul class="anlist" v-if="form.is_replace != '1'">
          <li v-for="(item, index) in agentList" :key="`alist_${index}`" style="margin-bottom: 20px;">
            <div class="abox">
              <el-form-item label="代理工作说明：" prop="work_reason">
                <el-col :span="6">
                  <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                    v-model="item.work_reason" clearable />
                </el-col>
              </el-form-item>
              <el-form-item label="职务代理人：" prop="agent_id">
                <el-col :span="6">
                  <el-select v-model="item.agent_id" placeholder="请输入职务代理人" style="margin-right: 0; width: 100%;">
                    <el-option :label="`${v.realname} ${v.en_name}`" :value="v.id" v-for="(v, i) in canAgentList"
                      :key="`aitem_${i}`"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </div>
            <el-button class="abtn" icon="el-icon-minus" @click="removeAgent(agentList, index)" circle></el-button>
          </li>
          <el-button type="primary" style="margin: 0 0 15px -5px" class="addbtn"
            @click="addAgent(agentList)">新增职务代理</el-button>
        </ul>
      </el-form>
      <div class="btnarea">
        <div class="left">
          <el-button @click="resetForm('form')">取消</el-button>
          <el-button type="primary" @click="submitForm('form', '1')" v-if="form.is_draft == '1' && !(form.is_replace == '1' && level =='1')">保存</el-button>
        </div>
        <div class="right">
          <el-button type="primary" @click="showConfirm">申请休假</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="休假确认" :visible.sync="confirmShow" width="600px">
      <ul class="aul ulist" style="padding:0; min-height: 100px;">
        <li>
          <span>休假类型：</span>
          <span>{{ dd.holidayType[form.holiday_id] }}</span>
        </li>
        <li v-if="form.start_time && form.end_time">
          <span>起止时间：</span>
          <span>{{ form.start_date }}{{ form.start_time == '1' ? '上午' : '下午' }} - {{ form.end_date }}{{ form.end_time ==
            '1'
            ? '上午' : '下午' }}</span>
        </li>
        <li>
          <span>申请天数：</span>
          <span>{{ form.apply_days_word }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ userArr.realname }} {{ userArr.en_name }}</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmShow = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form', '0')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="休假说明" :visible.sync="infoShow" width="800px" :close-on-click-modal="false" :show-close="false">
      <ul class="aul" style="padding:0">
        <li class="holi-body" v-for="(item, index) in holidayDetailList" :key="`holi_${index}`">
          <div class="hold-head-title">{{ item.name }}说明</div>
          <div class="hold-head-content" v-for="(_it, _id) in item.description" :key="`holiday_${_id}`">{{ _it }}</div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="infoShow = false" :disabled="isDisabled">{{ buttonWord }}</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
// import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'vacaAdd',
  data() {
    return {
      returnUrl: true, // 确实是否为手动按钮触发，还是右上角触发
      nodeLimtList: [],
      level: '',
      userId: '',
      uid: '',
      itemList: [],
      DepartList: [],
      userArr: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000; // 86400000 毫秒 = 1 天  
        }
      },
      form: {
        holiday_detail_id: '', //员工休假id
        is_draft: '1',
        is_creat: '',
        user_id: '', //user_id
        holiday_id: '',
        reason: '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        apply_days: '',
        day_type: '',
        apply_days_word: '',
        is_replace: '',// 待补假标识 （区分正常请假和他人代补假）
      },
      rules: {
        // client_company: [
        //   {
        //     required: true,
        //     message: '请输入客户公司名称',
        //     trigger: 'change',
        //   },
        // ],
        // brand: [
        //   {
        //     required: true,
        //     message: '请输入品牌',
        //     trigger: 'change',
        //   },
        // ],
      },
      job_file_list: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] },
      ],
      holidayDetail: {},
      holidayDetailList: {},
      typeList: [],
      del_job_list: [],
      canAgentList: [],
      agentList: [
        { id: '', agent_id: '', work_reason: '' },
      ],
      del_agent_list: [],
      confirmShow: false,
      restList: [],
      infoShow: false,
      isDisabled: false, // 控制按钮是否禁用  
      countdown: 5, // 倒计时剩余时间  
      buttonWord: '5秒后方可确认', // 倒计时剩余时间  
      intervalId: null,
    }
  },
  computed: {

  },
  created() {
    this.query = this.$route.query
    this.query.id && (this.form.holiday_detail_id = this.query.id) && this.getDetail(this.query.id)
    this.query.uid && (this.form.user_id = this.query.uid) 
    this.query.uid && this.getUserDetail(this.query.uid) 
    this.query.uid && this.getStoreFn()
  },
  mounted() {
    this.geHolidayInfo()
  },
  beforeRouteLeave(to, from, next) {
    if (this.returnUrl) {
      // 这里可以放置你的逻辑，比如提示用户  
      const answer = window.confirm('离开当前页面会保存');
      if (answer) {
        if (this.form.is_draft == '1') {
          this.addUpdateVacation(1, false) //false不让页面两次回退
        }
        else {
          this.addUpdateVacation(0, false) //false不让页面两次回退
        }
        next();
      } else {
        next(false); // 取消路由变更  
      }
    }
    next();
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },

    link(url) {
      this.$router.push(url)
    },

    getUserDetail(uid) {
      this.$fly
        .post('ApiStaffReimbursement_getStaffInfo.html', {
          uid: uid,
        })
        .then((res) => {
          this.userArr = res
        })
    },

    async geHolidayInfo(holiday_id) {
      let postData = {
        holiday_id,
      }
      api.getHolidayInfo(postData).then((res) => {
        if (holiday_id) {
          this.holidayDetail = res
        }
        else {
          this.holidayDetailList = res
        }
      })
    },

    async getHolidayType(uid, is_replace) {
      let postData = {
        user_id: uid,
        is_replace: is_replace,
      }
      api.getHolidayType(postData).then((res) => {
        this.typeList = res
      })
    },

    async getAgentList() {
      api.getAgentList({
        user_id: this.form.user_id,
      }).then((res) => {
        this.canAgentList = res
      })
    },

    getRestInfo(e) {
      this.$fly
        .post('ApiHoliday_getRestInfo.html', {
          user_id: this.form.user_id,
          holiday_id: e
        })
        .then((res) => {
          this.restList = res.length ? res : []
        })
    },

    getDetail(id) {
      api.getStaffHolidayDetail({
        holiday_detail_id: id,
      }).then((res) => {
        const {
          holiday_id,
          is_creat,
          is_draft,
          is_replace,
          reason,
          start_date,
          start_time,
          end_date,
          end_time,
          days,
          record_id,
          user_info,
        } = res
        this.form = {
          holiday_detail_id: id,
          is_creat,
          is_draft,
          is_replace,
          holiday_id,
          reason,
          start_date,
          start_time,
          end_date,
          end_time,
          apply_days: days,
          day_type: (holiday_id == '2' || holiday_id == '3' || holiday_id == '4') ? '1' : '2',
          record_id,
          user_id: user_info.id
        }
        this.form.apply_days_word = this.form.apply_days + (this.form.day_type == '1' ? '天(自然日)' : '天(工作日)')
        this.isDraft = res.is_draft
        this.getUserDetail(user_info.id)
        this.geHolidayInfo(holiday_id)
        this.form.holiday_id == '5' ? this.getRestInfo(holiday_id) : false
        this.job_file_list = res.staff_holiday_file.map(({ origin_name, file_name, httpFile, id }) => {
          return { origin_name, file_name, httpFile, file_id: id, fileList: [] }
        })
        this.agentList = res.job_agency_arr.map(({ id, agency_id, work_reason }) => {
          return { id, agent_id: agency_id, work_reason }
        })
        this.getStoreFn()
      })
    },

    getStoreFn() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      setTimeout(() => {
        //权限
        this.level = store.state.level
        this.userId = store.state.userId
        if (this.userId != this.form.user_id) {
          this.form.is_replace = '1'
        }
        this.getHolidayType(this.form.user_id, this.form.is_replace)
        this.getAgentList()// 获取代理人下拉列表
        if (!this.form.holiday_id) {
          if (this.form.is_replace == '1') {
            this.form.holiday_id = '6' // 代补假默认事假6
          } else {
            this.form.holiday_id = '1' // 自请假默认年假1
          } 
          this.infoShow = true
          if (!this.isDisabled) {
            this.isDisabled = true; // 禁用按钮  
            this.countdown = 5; // 设置倒计时为5秒  
            // 使用setInterval进行倒计时  
            this.intervalId = setInterval(() => {
              this.countdown--; // 倒计时减一  
              if (this.countdown <= 0) {
                clearInterval(this.intervalId); // 倒计时结束，清除定时器  
                this.isDisabled = false; // 重新启用按钮  
                this.countdown = 0; // 重置倒计时  
                this.buttonWord = `确 定`;
              }
              else {
                this.buttonWord = `${this.countdown}秒后方可确认`;
              }
            }, 1000); // 每秒执行一次  
          } else {
            this.buttonWord = `${this.countdown}秒后方可确认`;
          }          
        }
        this.geHolidayInfo(this.form.holiday_id) 
      }, 200);
    },

    holiInfoChange(e) {
      this.form.holiday_id = e;
      this.geHolidayInfo(e)
      if (e == '5') {
        this.getRestInfo(e)
      }
      else {
        this.form.record_id = ''
      }
      this.form =  {
        ...this.form,
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        apply_days: '',
        day_type:  (e == '2' || e == '3' || e == '4') ? '1' : '2',
        apply_days_word: '',
      }
    },

    detailDayChange() {
      const {
        holiday_id,
        start_date,
        start_time,
        end_date,
        end_time,
      } = this.form
      const postData = {
        holiday_id,
        start_date,
        start_time,
        end_date,
        end_time,
      }
      if (!postData.start_date || !postData.start_time || !postData.end_date || !postData.end_time) {
        this.form.apply_days_word = `请完善时间获取天数`
        return false
      }
      this.$fly
        .post('ApiHoliday_getWorkDay.html', {
          user_id: this.form.user_id,
          ...postData,
        })
        .then((res) => {
          this.form.apply_days = res.day
          this.form.apply_days_word = res.day + (this.form.day_type == '1' ? '天(自然日)' : '天(工作日)')
        })
    },

    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 6);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addJob(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', file_id: '', flist: []
      });
    },

    removeJob(arr, index) {
      if (arr[index].file_id) {
        this.del_job_list.push(arr[index].file_id);
      }
      console.log(this.del_job_list);
      arr = arr.splice(index, 1);
    },

    addAgent(arr) {
      arr.push({ id: '', origin_name: '', work_reason: '', });
    },

    removeAgent(arr, index) {
      if (arr[index].id) {
        this.del_agent_list.push(arr[index].id);
      }
      console.log(this.del_agent_list);
      arr = arr.splice(index, 1);
    },

    submitForm(formName, is_draft = '1') {
      this.returnUrl = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateVacation(is_draft, true)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    addUpdateVacation(is_draft = '1', canReturn = true) {
      this.form.holiday_detail_id = this.query.id || ''
      this.form.option = this.form.holiday_detail_id ? '2' : '1'
      const tempForm = JSON.parse(JSON.stringify(this.form))
      const url = (this.level == '1' && this.form.is_replace == '1') ? 'ApiHoliday_applyHolidayByManager.html' : 'ApiHoliday_applyHoliday.html'
      this.$fly
        .post(url, {
          ...tempForm,
          job_file: JSON.stringify(this.job_file_list),
          agent_str: JSON.stringify(this.agentList),
          file_del_str: this.del_job_list.toString(),
          agent_del_str: this.del_agent_list.toString(),
          is_draft: is_draft,
          is_creat: (this.form.option == '2' && this.isDraft != is_draft) ? '1' : '',
          //isDraft为临时存储接收到的is_draft
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          if (canReturn) {
            this.$router.go(-1)
          }
        })
    },

    resetForm(formName) {
      this.returnUrl = false
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },

    showConfirm() {
      this.confirmShow = true;
    },

  },
}
</script>

<style lang="scss" scoped>
.userdetail {
  .holiday-head {
    @extend %box;
    @extend %start;
    align-items: center;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .holi-body {
      &.left {
        width: 70%;

        .hold-head-title {
          font: 600 28px/1 $font;
        }

        .hold-head-content {
          padding: 10px 0;

          div {
            font: 400 16px/1.5 $font;
          }
        }
      }

      &.right {
        width: 30%;

        .holiday-box {
          @extend %center;
          width: 180px;
          height: 80px;
          padding: 10px;
          color: #fff;
          border-radius: 10px;

          &.holi1 {
            background: #02a7f0;
          }

          &.holi2 {
            background: #ec808d;
          }

          &.holi3 {
            background: #81d3f8;
          }

          &.holi4 {
            background: #81d3f8;
          }

          &.holi5 {
            background: #70b603;
          }

          &.holi6 {
            background: #f59a23;
          }

          &.holi7 {
            background: #8400ff;
          }

          &.holi8 {
            background: #333333;
          }

          .box-title {
            font: 600 24px/1 $font;
            margin-bottom: 10px;
          }

          .box-info {
            font: 400 20px/1 $font;
          }
        }
      }
    }
  }

  .history {
    @extend %box;
    padding: 30px 40px;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }
        }
      }
    }
  }

  .btnarea {
    @extend %start;
    padding: 30px 0;
    position: relative;

    .left {
      width: 500px;
    }

    .right {
      width: 300px;
    }
  }

  .table {
    @extend %box;
    padding: 20px 40px;
    margin-bottom: 20px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #fff;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 40%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }
        }

        &:last-child {
          width: 60%;
          box-sizing: border-box;
          padding-left: 85px;
        }
      }
    }

    .for-title {
      font: 700 24px/1.5 $font;
      color: #444041;
    }

    .for {
      padding: 25px 0;

      &.grey {
        padding: 25px 20px;
        border-radius: 20px;
        background: #f2f2f2;
        margin-bottom: 20px;
      }

      ul {
        @extend %start;
        color: #231f20;
        background: #f2f2f2;
        padding: 0 25px;
        border-radius: 20px;
        margin-bottom: 20px;
        position: relative;

        &:last-of-type {
          margin-bottom: 0;
        }

        li {
          width: 40%;
          font: 14px/3 $font;

          p {
            height: 42px;
            @extend %start;

            label {
              width: 150px;
              white-space: nowrap;
              flex: none;
            }

            span {
              white-space: nowrap;
            }
          }

          &:last-child {
            width: 60%;
            box-sizing: border-box;
            padding-left: 85px;
          }
        }
      }

      .el-button {
        float: right;
        margin-bottom: 10px;
        position: relative;
      }
    }
  }

  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}

.holi-body {
  text-align: left;

  .hold-head-title {
    padding: 10px 0;
    font: 600 20px/1 $font;
  }

  .hold-head-content {
    padding: 10px 0;

    div {
      font: 400 16px/1.5 $font;
    }
  }

}
</style>
